module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/257IxdOLaweycmQMgMiIi6-b5a3c90481a8532b49a76d32c5075906.jpg";